/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user" | "TradeOnboardingCoachmarkConditionalLoader_user">;
    readonly " $refType": "SbRespRefineTopFilters_user";
};
export type SbRespRefineTopFilters_user$data = SbRespRefineTopFilters_user;
export type SbRespRefineTopFilters_user$key = {
    readonly " $data"?: SbRespRefineTopFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopFilters_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineTopFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = '7a5e2a29fad608fcd33748f380959e8f';
export default node;
